document.addEventListener('DOMContentLoaded', function() {
  // Find Brands menu item
  const brandsLink = Array.from(document.querySelectorAll('span')).find(el => 
    el.textContent.trim() === 'Brands'
  )?.closest('a');
  
  if (!brandsLink) return;
  
  const brandsMenuItem = brandsLink.closest('li');
  brandsMenuItem.classList.remove('no-megamenu');
  brandsMenuItem.classList.add('has-megamenu');
  
  // Make parent container relative for absolute positioning
  brandsMenuItem.style.position = 'relative';
  
  // Get dynamic vendors
  const vendors = window.shopifyVendors || [];
  let selectedDesigners = JSON.parse(localStorage.getItem('selectedDesigners')) || [];
  let recentlyBrowsed = JSON.parse(localStorage.getItem('recentlyBrowsed')) || [];
  
  const megaMenuHTML = `
    <div class="brands-megamenu" style="position: fixed; top: 80px; left: 0; width: 100vw; background: white; border-top: 1px solid #ddd; display: none; z-index: 9999; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
      <div style="max-width: 1200px; margin: 0 auto;">
      <style>
        .brands-megamenu { 
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; 
          font-size: 14px; 
          width: 100%;
          padding: 30px 40px;
        }
        .mega-header {
          margin-bottom: 20px;
        }
        .mega-title { 
          font-size: 16px; 
          font-weight: 600; 
          margin-bottom: 15px; 
          color: #333;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .mega-title a {
          font-size: 12px;
          color: #666;
          text-decoration: underline;
          font-weight: normal;
          text-transform: lowercase;
          letter-spacing: normal;
          margin-left: 8px;
        }
        .alphabet-nav { 
          display: flex; 
          gap: 15px; 
          margin-bottom: 30px; 
          font-size: 14px;
          align-items: center;
        }
        .alphabet-nav .heart-icon {
          color: #333;
          font-size: 16px;
        }
        .alphabet-nav a { 
          color: #999; 
          text-decoration: none; 
          cursor: pointer;
          font-weight: 500;
          transition: color 0.2s ease;
        }
        .alphabet-nav a:hover, .alphabet-nav a.active { 
          color: #333; 
        }
        .mega-content {
  display: grid;
  grid-template-columns: 300px 1fr; /* Left image + right content */
  gap: 40px;
  margin-bottom: 30px;
}

.image-column {
  display: flex;
  align-items: flex-start;
}

.mega-left-image {
  width: 100%;
  max-width: 280px;   /* adjust to fit */
  height: auto;
  border-radius: 8px;
  object-fit: cover;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.content-column {
  display: flex;
  flex-direction: column;
}

.mega-content-right {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Designers + Brands */
  gap: 60px;
  margin-bottom: 30px;
}

        .image-column img {
          width: 100%;
          height: auto;
          border-radius: 8px;
          object-fit: cover;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }
        .section-title { 
          font-size: 14px; 
          font-weight: 600; 
          margin-bottom: 20px; 
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #333;
        }
        .designers-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 30px;
        }
        .designer-list, .brand-list { 
          display: flex; 
          flex-direction: column; 
          gap: 8px;
          max-height: 300px;
          overflow-y: auto;
        }
        .designer-item, .brand-item { 
          cursor: pointer; 
          padding: 3px 0;
          transition: background-color 0.2s ease;
        }
        .designer-item:hover, .brand-item:hover { 
          background-color: #f8f8f8; 
        }
        .designer-name, .brand-name { 
          color: #333; 
          text-decoration: none; 
          font-size: 14px;
          display: block;
          width: 100%;
        }
        .designer-name:hover, .brand-name:hover {
          color: #666;
        }
        .brands-you-love {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .recently-browsed {
          padding-top: 20px;
          border-top: 1px solid #eee;
        }
        .recently-browsed .section-title {
          margin-bottom: 15px;
        }
        .tag-list {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }
        .tag {
          background: #f5f5f5;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          color: #666;
          border: 1px solid #eee;
          cursor: pointer;
          transition: all 0.2s ease;
          text-decoration: none;
        }
        .tag:hover {
          background: #ececec;
          color: #333;
        }
        .empty-state {
          color: #999;
          font-style: italic;
        }
          .section-title {
  display: flex;
  align-items: center;
  gap: 6px; /* space between text and icon */
}

.section-title .instagram-icon-img {
  width: 16px;   /* adjust to match text size */
  height: 16px;
  object-fit: contain;
  display: inline-block;
}
      </style>
      
      <div class="mega-content">
  <!-- Left image column -->
  <div class="image-column">
    <img src="https://cdn.shopify.com/s/files/1/0940/4245/6394/files/MegaMenu_Drop_Downs_2_d9901913-7d95-4cee-b62a-cb119fa4863b.svg?v=1764534761" 
         alt="Promo Image" class="mega-left-image">
  </div>

  <!-- Right content (unchanged) -->
  <div class="content-column">
    <div class="mega-header">
      <div class="mega-title">Designers A-Z <a href="/pages/designers-a-z">view all</a></div>
      <div class="alphabet-nav">
        <span class="hash-icon">#</span>
        ${'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(letter => 
          `<a href="#" data-letter="${letter}">${letter}</a>`
        ).join('')}
      </div>
    </div>

    <div class="mega-content-right">
      <div class="designers-column">
        <div class="section-title">Designers</div>
        <div class="designers-grid">
          <div class="designer-list" id="designerListCol1"></div>
          <div class="designer-list" id="designerListCol2"></div>
        </div>
      </div>
      
      <div class="brands-column">
        <div class="section-title">Brands You'll <img src="https://cdn.shopify.com/s/files/1/0940/4245/6394/files/svgviewer-png-output.png?v=1755617509" 
       alt="Instagram" class="instagram-icon-img"></div>
        <div class="brands-you-love" id="brandsYouLove"></div>
      </div>
    </div>

    <div class="recently-browsed">
      <div class="section-title">Recently Browsed</div>
      <div class="tag-list" id="recentlyBrowsedTags"></div>
    </div>
  </div>
</div>`;
  
  brandsMenuItem.insertAdjacentHTML('beforeend', megaMenuHTML);
  
  // Position mega menu directly under header
  function positionMegaMenu() {
    const megaMenu = brandsMenuItem.querySelector('.brands-megamenu');
    if (!megaMenu) return;
    
    // Try to find the navigation container by working up from the brands menu item
    let navContainer = brandsMenuItem;
    while (navContainer && navContainer !== document.body) {
      if (navContainer.tagName === 'NAV' || 
          navContainer.classList.contains('navigation') ||
          navContainer.classList.contains('navbar') ||
          navContainer.classList.contains('header') ||
          navContainer.classList.contains('site-header') ||
          navContainer.id === 'header' ||
          navContainer.tagName === 'HEADER') {
        break;
      }
      navContainer = navContainer.parentElement;
    }
    
    if (navContainer && navContainer !== document.body) {
      const navRect = navContainer.getBoundingClientRect();
      megaMenu.style.top = navRect.bottom + 'px';
    } else {
      // Fallback: position based on brands menu item itself
      const brandsRect = brandsMenuItem.getBoundingClientRect();
      megaMenu.style.top = brandsRect.bottom + 'px';
    }
  }
  
  // Show/hide functionality
  brandsLink.addEventListener('mouseenter', () => {
    positionMegaMenu();
    brandsMenuItem.querySelector('.brands-megamenu').style.display = 'block';
    loadDesigners('A');
    loadBrandsYouLove();
    loadRecentlyBrowsed();
  });
  
  brandsMenuItem.addEventListener('mouseleave', () => {
    brandsMenuItem.querySelector('.brands-megamenu').style.display = 'none';
  });
  
  // Keep mega menu open when hovering over it
  const megaMenuElement = brandsMenuItem.querySelector('.brands-megamenu');
  megaMenuElement.addEventListener('mouseenter', () => {
    megaMenuElement.style.display = 'block';
  });
  
  megaMenuElement.addEventListener('mouseleave', () => {
    megaMenuElement.style.display = 'none';
  });
  
  // A-Z navigation
  brandsMenuItem.querySelectorAll('.alphabet-nav a').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const letter = e.target.dataset.letter;
      loadDesigners(letter);
      
      brandsMenuItem.querySelectorAll('.alphabet-nav a').forEach(a => a.classList.remove('active'));
      e.target.classList.add('active');
    });
  });
  
  // Load designers dynamically by letter in 2 columns (no hearts)
  function loadDesigners(letter) {
    const col1 = brandsMenuItem.querySelector('#designerListCol1');
    const col2 = brandsMenuItem.querySelector('#designerListCol2');
    
    let filteredVendors;
    if (letter === '#') {
      filteredVendors = vendors.filter(vendor => !/^[A-Z]/i.test(vendor));
    } else {
      filteredVendors = vendors.filter(vendor => vendor.charAt(0).toUpperCase() === letter);
    }
    
    // Split into 2 columns
    const mid = Math.ceil(filteredVendors.length / 2);
    const firstHalf = filteredVendors.slice(0, mid);
    const secondHalf = filteredVendors.slice(mid);
    
    function createDesignerHTML(vendor) {
      return `
        <div class="designer-item" onclick="visitVendor('${vendor}')">
          <span class="designer-name">${vendor}</span>
        </div>
      `;
    }
    
    col1.innerHTML = firstHalf.map(createDesignerHTML).join('') || '<div class="empty-state">No designers found</div>';
    col2.innerHTML = secondHalf.map(createDesignerHTML).join('');
  }
  
  // Load "Brands You'll Love" from favorites
  function loadBrandsYouLove() {
    const brandsYouLove = brandsMenuItem.querySelector('#brandsYouLove');
    
    if (selectedDesigners.length === 0) {
      // Show some popular brands if no favorites
      const popularBrands = vendors.slice(0, 10);
      const brandsHTML = popularBrands.map(brand => `
        <div class="brand-item" onclick="visitVendor('${brand}')">
          <span class="brand-name">${brand}</span>
        </div>
      `).join('');
      brandsYouLove.innerHTML = brandsHTML || '<div class="empty-state">No brands available</div>';
    } else {
      const brandsHTML = selectedDesigners.slice(0, 10).map(designer => `
        <div class="brand-item" onclick="visitVendor('${designer}')">
          <span class="brand-name">${designer}</span>
        </div>
      `).join('');
      brandsYouLove.innerHTML = brandsHTML;
    }
  }
  
  // Load recently browsed tags (functional)
  function loadRecentlyBrowsed() {
    const recentlyBrowsedTags = brandsMenuItem.querySelector('#recentlyBrowsedTags');
    
    if (recentlyBrowsed.length === 0) {
      recentlyBrowsedTags.innerHTML = '<div class="empty-state">No recent browsing history</div>';
      return;
    }
    
    const tagsHTML = recentlyBrowsed.slice(0, 8).map(tag => 
      `<span class="tag" onclick="visitVendor('${tag}')">${tag}</span>`
    ).join('');
    
    recentlyBrowsedTags.innerHTML = tagsHTML;
  }
  
  // Visit vendor and add to recently browsed
  window.visitVendor = function(vendorName) {
    // Add to recently browsed
    if (!recentlyBrowsed.includes(vendorName)) {
      recentlyBrowsed.unshift(vendorName);
      if (recentlyBrowsed.length > 10) {
        recentlyBrowsed = recentlyBrowsed.slice(0, 10);
      }
      localStorage.setItem('recentlyBrowsed', JSON.stringify(recentlyBrowsed));
    }
    
    // Navigate to vendor page
    window.location.href = `/collections/vendors?q=${encodeURIComponent(vendorName)}`;
  };
  
  // Initialize with 'A' active
  setTimeout(() => {
    const firstLetter = brandsMenuItem.querySelector('.alphabet-nav a[data-letter="A"]');
    if (firstLetter) firstLetter.classList.add('active');
  }, 100);
});